<template>
  <card>
    <svg-plot :config="set3.config">
      <svg-columns :series="set3.series" />
    </svg-plot>
  </card>
</template>

<script>
import Card from '@/components/charts/dev/Card.vue'
import SvgPlot from '@/components/charts/svg/plot/Plot.vue'
import SvgColumns from '@/components/charts/svg/plot/Columns.vue'
import { colors } from '@/plugins/colors.js'

export default {
  components: {
    Card,
    SvgPlot,
    SvgColumns
  },
  computed: {
    set1 () {
      return {
        config: {
          grid: { vertical: true },
          axis: { x: [{ value: 0, label: 'Апр' }, { value: 1, label: 'Май' }] },
          spaces: { left: 100, right: 50, chartBottom: 50 }
        },
        series: [
          {
            x: 0,
            columns: [
              { value: 100, color: colors[0], label: '100' },
              { value: 75, color: colors[1], label: '75' },
              { value: 50, color: colors[2], label: '50' },
              { value: 25, color: colors[3], label: '25' }
            ]
          },
          {
            x: 1,
            columns: [
              { value: 50, color: colors[0], label: '50' },
              { value: 25, color: colors[1], label: '25' }
            ]
          }
        ]
      }
    },
    set2 () {
      return {
        config: {
          grid: { vertical: true },
          axis: { x: [{ value: 0, label: 'Апр' }] },
          spaces: { left: 100, right: 50, chartBottom: 50 }
        },
        series: [
          {
            x: 0,
            columns: [
              { value: 100, color: colors[0], label: '100' },
              { value: 75, color: colors[1], label: '75' },
              { value: 50, color: colors[2], label: '50' }// ,
              // { value: 25, color: colors[3], label: '25' }
            ]
          }
        ]
      }
    },
    set3 () {
      return {
        config: {
          grid: { vertical: true },
          axis: {
            x: [
              { value: 0, label: 'Апр' }, { value: 1, label: 'Май' }, { value: 2, label: 'Июн' },
              { value: 3, label: 'Июл' }, { value: 4, label: 'Авг' }, { value: 5, label: 'Сен' },
              { value: 6, label: 'Окт' }, { value: 7, label: 'Ноя' }, { value: 8, label: 'Дек' },
              { value: 9, label: 'Янв' }, { value: 10, label: 'Фев' }, { value: 11, label: 'Мар' },
              { value: 12, label: 'Апр' }, { value: 13, label: 'Май' }, { value: 14, label: 'Июн' },
              { value: 15, label: 'Июл' }, { value: 16, label: 'Авг' }, { value: 17, label: 'Сен' },
              { value: 18, label: 'Окт' }, { value: 19, label: 'Ноя' }, { value: 20, label: 'Дек' },
              { value: 21, label: 'Янв' }, { value: 22, label: 'Фев' }, { value: 23, label: 'Мар' }
            ]
          },
          spaces: { left: 50, right: 50, chartBottom: 50 }
        },
        series: [
          {
            x: 0,
            columns: [
              { value: 20, color: colors[0], label: '20' },
              { value: 80, color: colors[5], label: '80' },
              { value: 120, color: colors[1], label: '120' }
            ]
          },
          {
            x: 1,
            columns: [
              { value: 30, color: colors[0], label: '30' },
              { value: 130, color: colors[5], label: '130' },
              { value: 75, color: colors[1], label: '75' }
            ]
          },
          {
            x: 2,
            columns: [
              { value: 45, color: colors[0], label: '45' },
              { value: 65, color: colors[5], label: '65' },
              { value: 78, color: colors[1], label: '78' }
            ]
          },
          {
            x: 3,
            columns: [
              { value: 10, color: colors[0], label: '10' },
              { value: 65, color: colors[5], label: '65' },
              { value: 110, color: colors[1], label: '110' }
            ]
          },
          {
            x: 4,
            columns: [
              { value: 55, color: colors[0], label: '55' },
              { value: 26, color: colors[5], label: '26' },
              { value: 95, color: colors[1], label: '95' }
            ]
          },
          {
            x: 5,
            columns: [
              { value: 83, color: colors[0], label: '83' },
              { value: 48, color: colors[5], label: '48' },
              { value: 23, color: colors[1], label: '23' }
            ]
          },
          {
            x: 6,
            columns: [
              { value: 57, color: colors[0], label: '57' },
              { value: 12, color: colors[5], label: '12' },
              { value: 64, color: colors[1], label: '64' }
            ]
          },
          {
            x: 7,
            columns: [
              { value: 23, color: colors[0], label: '23' },
              { value: 76, color: colors[5], label: '76' },
              { value: 34, color: colors[1], label: '34' }
            ]
          },
          {
            x: 8,
            columns: [
              { value: 99, color: colors[0], label: '99' },
              { value: 110, color: colors[5], label: '110' },
              { value: 24, color: colors[1], label: '24' }
            ]
          },
          {
            x: 9,
            columns: [
              { value: 74, color: colors[0], label: '74' },
              { value: 98, color: colors[5], label: '98' },
              { value: 35, color: colors[1], label: '35' }
            ]
          },
          {
            x: 10,
            columns: [
              { value: 26, color: colors[0], label: '26' },
              { value: 84, color: colors[5], label: '84' },
              { value: 51, color: colors[1], label: '51' }
            ]
          },
          {
            x: 11,
            columns: [
              { value: 73, color: colors[0], label: '73' },
              { value: 25, color: colors[5], label: '25' },
              { value: 47, color: colors[1], label: '47' }
            ]
          },
          {
            x: 12,
            columns: [
              { value: 86, color: colors[0], label: '86' },
              { value: 46, color: colors[5], label: '46' },
              { value: 38, color: colors[1], label: '38' }
            ]
          },
          {
            x: 13,
            columns: [
              { value: 74, color: colors[0], label: '74' },
              { value: 58, color: colors[5], label: '58' },
              { value: 16, color: colors[1], label: '16' }
            ]
          },
          {
            x: 14,
            columns: [
              { value: 52, color: colors[0], label: '52' },
              { value: 63, color: colors[5], label: '63' },
              { value: 26, color: colors[1], label: '26' }
            ]
          },
          {
            x: 15,
            columns: [
              { value: 82, color: colors[0], label: '82' },
              { value: 62, color: colors[5], label: '62' },
              { value: 42, color: colors[1], label: '42' }
            ]
          },
          {
            x: 16,
            columns: [
              { value: 37, color: colors[0], label: '37' },
              { value: 93, color: colors[5], label: '93' },
              { value: 53, color: colors[1], label: '53' }
            ]
          },
          {
            x: 17,
            columns: [
              { value: 14, color: colors[0], label: '14' },
              { value: 25, color: colors[5], label: '25' },
              { value: 84, color: colors[1], label: '84' }
            ]
          },
          {
            x: 18,
            columns: [
              { value: 52, color: colors[0], label: '52' },
              { value: 11, color: colors[5], label: '11' },
              { value: 55, color: colors[1], label: '55' }
            ]
          },
          {
            x: 19,
            columns: [
              { value: 46, color: colors[0], label: '46' },
              { value: 95, color: colors[5], label: '95' }
            ]
          },
          {
            x: 20,
            columns: [
              { value: 95, color: colors[0], label: '95' }
            ]
          },
          {
            x: 21,
            columns: [
              { value: 26, color: colors[0], label: '26' },
              { value: 62, color: colors[5], label: '26' },
              { value: 74, color: colors[1], label: '74' }
            ]
          },
          {
            x: 22,
            columns: [
              { value: 120, color: colors[0], label: '120' },
              { value: 52, color: colors[5], label: '52' },
              { value: 47, color: colors[1], label: '74' },
              { value: 12, color: colors[2], label: '12' }
            ]
          },
          {
            x: 23,
            columns: [
              { value: 73, color: colors[0], label: '73' },
              { value: 84, color: colors[5], label: '84' },
              { value: 24, color: colors[1], label: '24' }
            ]
          }
        ]
      }
    }
  }
}
</script>
